<template>
  <div :class="{ 'invalid': !isValid, 'valid': isValid}">
    <label :for="name">List of subparts</label>
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <div class="dynamic-inputs flex-col" ref="scrollable">
      <!-- <VerticalStepBullets class="steps-bullets" :totalSteps="this.newParts.length" :currentStep="this.newParts.length" /> -->
      <div class="steps-list">
        <div 
          class="step-group group-w-button"
          v-for="(val, index) in this.newParts" 
          :key="index"
        > 
          <div class="step-fields-double">
            <input 
              class="amount" 
              :class="{'autocomplete-active': autocompleteIndex == index}" 
              autocomplete="off" 
              type="number" 
              :name="`newParts[${index}][amount]`" 
              v-model="val.amount" 
              placeholder="amount" 
              @keyup.enter="gotSelectionPart(stepsResult[0])"
            /> 
            <input class="ref" :class="{'autocomplete-active': autocompleteIndex == index}" autocomplete="off" type="text" :name="`newParts[${index}][name]`" v-model="val.name" placeholder="Search" @input="updateParts(index)" @focus="openComplete(index)"/>
          </div>
          <input autocomplete="off" type="text" :name="`newParts[${index}][id]`" v-model="val.id" style="display:none;" /> 
          <BaseIcon name="times-circle" class="icon ico-delete" :class="{'delete-disabled': newParts.length == 1, 'detailed-list': isDetailed}" @click.native="removePart(index)"/>
          
          <AutocompleteSubparts class="step-autocomp-double" v-if="autocompleteIndex == index && stepsResult.length > 0" :searchResults="stepsResult" @selectedPart="gotSelectionPart"/>
        </div>
        <div class="add-step-button" @click="addNewPart" :class="{'detailed-list': isDetailed}">
          <BaseIcon name="plus-circle" class="icon" />
          <label>Add another subpart</label>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseIcon from "@/components/base/Icon";
  import InputDash from "@/components/base/InputDash";
  import VerticalStepBullets from "@/components/base/VerticalStepBullets";
  import AutocompleteSubparts from "@/components/base/AutocompleteSubparts";
  import draggable from 'vuedraggable'

  export default {
    components: {
      BaseIcon, 
      InputDash,
      draggable,
      VerticalStepBullets,
      AutocompleteSubparts
    },
    props: {
      label: String,
      name: String,
      value: String,
      isTextArea: Boolean,
      isDisabled: Boolean,
      placeholder: String,
      value: String,
      isDetailed: Boolean,
      currentParts: Array
    },
    data() {
      return {
        stepsResult:[],
        newParts: 
        [
          {
            id: '',
            name: '',
            amount: '',
          },
          {
            id: '',
            name: '',
            amount: '',
          },          
          {
            id: '',
            name: '',
            amount: '',
          }
        ],
        autocompleteIndex: 99999,
        isValid: true,
        errorDescription: 'Test can not be empty',
      }
    }, 
    mounted() {
      this.setStartValues()
    },
    methods: {
      setStartValues() {
        if(this.currentParts != null && this.currentParts != "" && this.currentParts != undefined) {
          this.newParts = []
          this.newParts = this.currentParts
        }
      },
      checkMove: function(e) {
        window.console.log("Future index: " + e.draggedContext.futureIndex);
      },
      addNewPart() {
        this.newParts.push({
          id: '',
          name: '',
          amount: '',
        })
      },
      updateParts(index) {
        this.getParts(index)
        this.$emit('updateParts', this.newParts)
        this.scrollToEnd()
      },
      scrollToEnd() {
        var container = this.$refs.scrollable
        container.scrollTop = container.scrollHeight + 84;
      },
      getParts(index) {
        var that = this
        if (this.newParts[index].name != "") {
          this.$http.get(this.$endpoint + 'management/devices/subparts/search/' + this.newParts[index].name)
          .then(response => {
            that.stepsResult = response.data
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch(err => console.log(err));
            } else {
              that.$swal(
                'Oops that went wrong?',
                `Please contact the admin with the following info: ${ error }`,
                'error'
              );
            }
          })
        }
      },
      removePart(index) {
        if (this.newParts.length > 1) {
          this.newParts.splice(index, 1);
        }
      },
      openComplete(index) {
        this.autocompleteIndex = index
      },
      resetAutocompleteIndex(){
        this.autocompleteIndex = 99999
      },
      gotSelectionPart(selectedPart) {
        this.newParts[this.autocompleteIndex].id = selectedPart.deviceID
        this.newParts[this.autocompleteIndex].name = selectedPart.ref
        this.resetAutocompleteIndex()
        this.stepsResult = []
      },
      sumbitForm() {
        const data = {
          newParts: this.newParts
        }
        alert(JSON.stringify(data, null, 2))
      }
    },
  }
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";
@import "@/style/components/dynamicInputList";

::placeholder{
  color: #EFEFEF;
}

.step-autocomp-double {
  margin-left: 31.75%;
  width: 56.25% !important;
}
</style>
